import React from 'react'

import { useTheme } from '../../contexts/ThemeContext'

import Styled from './WaveOverlay.styled'

const WaveOverlay = ({ className, tagName }) => {
  const { theme } = useTheme()
  return <Styled className={className} as={tagName} theme={theme} />
}

export default WaveOverlay
